import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListTopics } from "../../../components/Admin/Topics/ListTopics/ListTopics";
import { useLanguage } from "../../../contexts";
import "./Topics.scss";

export function Topics() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("active_topics"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListTopics active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_topics"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListTopics active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="topics-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="topics-page-header-wrapper">
        <div className="topics-page-header">
          <span className="topics-page-title">{t("training_topics")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
